var D = Object.defineProperty;
var w = (t, e, s) => e in t ? D(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var u = (t, e, s) => (w(t, typeof e != "symbol" ? e + "" : e, s), s);
import { jsxs as I, jsx as g } from "react/jsx-runtime";
import { useState as E } from "react";
import { a as M, b as N, c as T, d as j, S as A, v as F, M as y } from "../sortable.esm-c91ac06a.js";
function B(t, e, s) {
  const o = {
    ...t
  };
  return e.top + t.y <= s.top ? o.y = s.top - e.top : e.bottom + t.y >= s.top + s.height && (o.y = s.top + s.height - e.bottom), e.left + t.x <= s.left ? o.x = s.left - e.left : e.right + t.x >= s.left + s.width && (o.x = s.left + s.width - e.right), o;
}
const C = (t) => {
  let {
    transform: e
  } = t;
  return {
    ...e,
    x: 0
  };
}, H = (t) => {
  let {
    transform: e,
    draggingNodeRect: s,
    windowRect: o
  } = t;
  return !s || !o ? e : B(e, s, o);
};
function L(t, e, s) {
  const o = e < 0 ? t.length + e : e;
  if (o >= 0 && o < t.length) {
    const r = s < 0 ? t.length + s : s, [l] = t.splice(e, 1);
    t.splice(r, 0, l);
  }
}
function V(t, e, s) {
  return t = [...t], L(t, e, s), t;
}
function W(t) {
  let e = t;
  for (; e; ) {
    if (e.dataset && e.dataset.noDnd)
      return !1;
    e = e.parentElement;
  }
  return !0;
}
class m extends y {
}
u(m, "activators", [
  {
    eventName: "onMouseDown",
    handler: ({ nativeEvent: e }) => W(e.target)
  }
]);
const x = (t) => Number(t) - 1, $ = (t) => t + 1, J = ({ value: t, overlayRender: e, handleChange: s, children: o }) => {
  const [r, l] = E(), p = M(
    N(m)
  );
  function v(i) {
    const { active: n } = i;
    l(n.id);
  }
  function S(i) {
    const { active: n, over: a } = i;
    if (n && a && n.id !== a.id) {
      const d = t.findIndex((h, c) => c === x(n.id)), f = t.findIndex((h, c) => c === x(a.id));
      s == null || s(V(t, d, f), d, f);
    }
    l(void 0);
  }
  return /* @__PURE__ */ I(
    T,
    {
      sensors: p,
      collisionDetection: j,
      onDragStart: v,
      onDragEnd: S,
      modifiers: [C, H],
      children: [
        /* @__PURE__ */ g(A, { items: t.map((i, n) => ({
          ...i,
          id: $(n)
        })), strategy: F, children: o }),
        r && e(Number(r))
      ]
    }
  );
};
export {
  J as default,
  $ as getIdFromIndex,
  x as getIndexFromID
};
//# sourceMappingURL=SortableContainerContext.js.map
